import { DetailsModal } from 'features/account/orders/details-modal';
import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';

import { DetailsModal as LegacyDetailsModal } from 'pages/account/account-orders/details-modal';

export default function AccountOrderDetail() {
  const enableMinimalCartUi = useMinimalCartUi();

  return enableMinimalCartUi ? <DetailsModal /> : <LegacyDetailsModal />;
}
